var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedAlertFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00011 15.5002C3.86455 15.5002 0.5 12.1357 0.5 8.00011C0.5 3.86455 3.86455 0.5 8.00011 0.5C12.1357 0.5 15.5002 3.86455 15.5002 8.00011C15.5002 12.1357 12.1357 15.5002 8.00011 15.5002Z",
    fill: "#A30F28",
    stroke: "#A30F28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42335 8.00012L10.9113 5.51218C11.0286 5.39488 11.0286 5.20528 10.9113 5.08798C10.794 4.97067 10.6044 4.97067 10.4871 5.08798L7.99914 7.57591L5.51121 5.08798C5.3939 4.97067 5.2043 4.97067 5.087 5.08798C4.9697 5.20528 4.9697 5.39488 5.087 5.51218L7.57494 8.00012L5.087 10.4881C4.9697 10.6054 4.9697 10.795 5.087 10.9123C5.1455 10.9708 5.2223 11.0002 5.2991 11.0002C5.3759 11.0002 5.45271 10.9708 5.51121 10.9123L7.99914 8.42433L10.4871 10.9123C10.5456 10.9708 10.6224 11.0002 10.6992 11.0002C10.776 11.0002 10.8528 10.9708 10.9113 10.9123C11.0286 10.795 11.0286 10.6054 10.9113 10.4881L8.42335 8.00012Z",
    fill: "white",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedAlertFill);
export default __webpack_public_path__ + "static/media/RedAlertFill.5b84c04fdbd3ca2699092d1f6180934a.svg";
export { ForwardRef as ReactComponent };